import BaseModelAPI from '../BaseModelAPI';

export default class CombineCaseDetail extends BaseModelAPI {
	static entity = 'combinecasedetail';
	static entityName = 'combinecasedetail';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.combineCaseId = '';
			this.combineCase = {};
			this.controlCardId = '';
			this.controlCard = {};
			this.qtyControlCard = 0;
			this.qtyAfter = 0;
			this.takenQty = 0;
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.isScanned = '';
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}